import utils from '../libs/utils';
import axios from './axios';

const baseUrl = 'v1/erp-operate-web';
const businessUrl = 'v1/erp-business-web'; // SAP单据关联关系查询的baseUrl
const baseWebUrl = '/v1/erp-base-web';

// 经营工具
export default {
  supplierPrimarySubmit(params) { // 提交供应商主键 - 提交
    return axios.post(`${baseUrl}/supplierKey/update`, params); // 后端需要JSON对象
  },

  // 供应商主键列表
  getSupplierPrimaryList(params) {
    return axios.get(`${baseUrl}/supplierKey/list/changed?${utils.exchangeParams(params)}`);
  },

  // 供应商主键操作日志
  getSupplierPrimaryOperationLogList(params) {
    return axios.get(`${baseUrl}/supplierKey/getOperate?${utils.exchangeParams(params)}`);
  },

  // 商品主键列表
  getGoodsPrimaryList(params) {
    return axios.get(`${baseUrl}/goodsKey/list/changed?${utils.exchangeParams(params)}`);
  },

  // 商品主键操作日志
  getGoodsPrimaryOperationLogList(params) {
    return axios.get(`${baseUrl}/goodsKey/getOperate?${utils.exchangeParams(params)}`);
  },

  // 查看可编辑的商品
  getGoodsPrimaryAbleList(params) {
    return axios.get(`${baseUrl}/goodsKey/list?${utils.exchangeParams(params)}`);
  },
  // 提交商品主键
  goodsPrimarySubmit(params) {
    return axios.post(`${baseUrl}/goodsKey/edit`, params);
  },

  // 合并相同商品列表
  getMergeEqualGoodsList(params) {
    return axios.get(`${baseUrl}/goodsBase/list/changed?${utils.exchangeParams(params)}`);
  },

  // 提交合并相同商品
  getMergeEqualSubmit(params) {
    return axios.post(`${baseUrl}/goodsBase/cleanse`, params);
  },

  // 查看已合并商品关联的业务表
  getMergeEqualGoodsRelBizList(params) {
    return axios.get(`${baseUrl}/goodsBase/getRelBiz?${utils.exchangeParams(params)}`);
  },

  // 进项税率修改记录
  getInputTaxRateList(params) {
    return axios.get(`${baseUrl}/purTax/list/changed?${utils.exchangeParams(params)}`);
  },
  // 进项税率操作日志
  getInputTaxRateLogList(params) {
    return axios.get(`${baseUrl}/purTax/getOperate?${utils.exchangeParams(params)}`);
  },
  // 新增进项税率修改 - 提交
  inputTaxRateUpdateSubmit(params) {
    return axios.post(`${baseUrl}/purTax/cleanse`, params);
  },

  // 进价修改记录
  getPriceWithTaxList(params) {
    return axios.get(`${baseUrl}/inputPrice/list/changed?${utils.exchangeParams(params)}`);
  },
  // 进价修改操作日志
  getPriceWithTaxLogList(params) {
    return axios.get(`${baseUrl}/inputPrice/getOperate?${utils.exchangeParams(params)}`);
  },
  // 新增进价修改 - 提交
  priceWithTaxUpdateSubmit(params) {
    return axios.post(`${baseUrl}/inputPrice/update`, params);
  },

  // 销项税率修改记录
  getOutputTaxRateList(params) {
    return axios.get(`${baseUrl}/outputTax/list/changed?${utils.exchangeParams(params)}`);
  },
  // 销项税率修改操作日志
  getOutputTaxRateLogList(params) {
    return axios.get(`${baseUrl}/outputTax/getOperate?${utils.exchangeParams(params)}`);
  },
  // 新增销项税率修改 - 提交
  outputTaxRateUpdateSubmit(params) {
    return axios.post(`${baseUrl}/outputTax/update`, params);
  },

  // 单据时间修改记录
  getBillsTimeList(params) {
    return axios.get(`${baseUrl}/financePayable/list?${utils.exchangeParams(params)}`);
  },
  // 新增单据时间修改 - 提交
  billsTimeUpdateSubmit(params) {
    return axios.post(`${baseUrl}/supplierKey/update`, utils.exchangeParams(params));
  },

  // 采购订单供应商修改记录
  purchaseSupplierList(params) {
    return axios.get(`${baseUrl}/financePayable/list?${utils.exchangeParams(params)}`);
  },
  // 新增采购订单供应商修改 - 提交
  purchaseSupplierSubmit(params) {
    return axios.post(`${baseUrl}/supplierKey/update`, utils.exchangeParams(params));
  },
  // 报表更新-患者复购提交接口
  updatePatientRebuy(params) {
    return axios.post(`${baseUrl}/report/update/patient/rebuy`, params);
  },
  updateReportList(params) { // 报表更新-列表
    return axios.get(`${baseUrl}/report/update/list?${utils.exchangeParams(params)}`);
  },
  updateReport(params) { // 报表更新-经营报表提交接口
    return axios.post(`${baseUrl}/report/update/report`, params);
  },
  downloadSapBillRelation(params) { // SAP关联查询导出Excel文件
    return axios.get(`${businessUrl}/sapBill/downloadSapBillRelation?${utils.exchangeParams(params)}`);
  },
  getSapBillRelationQuery(params) { // SAP关联关系查询条件
    return axios.get(`${businessUrl}/sapBill/getSapBillRelationQuery?${utils.exchangeParams(params)}`);
  },
  getSapBillRelationPage(params) { // SAP单据关联关系查询
    return axios.get(`${businessUrl}/sapBill/getSapBillRelationPage?${utils.exchangeParams(params)}`);
  },
  getPharmacyList(params) { // 药事服务
    return axios.get(`/v1/erp-base-web/pharmacy/configure/list?${utils.exchangeParams(params)}`);
  },
  updatePharmacyStatus(params) { // 药事服务修改开启关闭状态
    return axios.post('/v1/erp-base-web/pharmacy/configure/updateStatus', utils.exchangeParams(params));
  },
  getStoreAndAmount(params) { // 药事服务获取新增门店
    return axios.get(`/v1/erp-base-web/pharmacy/configure/getStoreAndAmount?${utils.exchangeParams(params)}`);
  },
  deletePharmacy(params) { // 药事服务删除
    return axios.post('/v1/erp-base-web/pharmacy/configure/delete', utils.exchangeParams(params));
  },
  addAndEditPharmacy(params) { // 药事服务提交
    return axios.post('/v1/erp-base-web/pharmacy/configure/addAndEdit', params);
  },
  getGoodsInfo(params) { // 药事服务查询药品
    return axios.get(`/v1/erp-base-web/pharmacy/configure/getGoodsInfo?${utils.exchangeParams(params)}`);
  },
  getTemplateList() { // 获取随访模版信息
    return axios.get('/v1/erp-business-web/pharmaceuticalCare/templateList');
  },
  getRuleList() { // 盘点规则列表查询
    return axios.get('/v1/erp-business-web/stocktaking/rule/getRuleList');
  },
  getRuleDetail(params) { // 盘点规则查看
    return axios.get(`/v1/erp-business-web/stocktaking/rule/getRuleDetail?${utils.exchangeParams(params)}`);
  },
  updateRule(params) { // 盘点规则更新
    return axios.post('/v1/erp-business-web/stocktaking/rule/update', params);
  },
  updateRuleStatus(params) {
    return axios.post('/v1/erp-business-web/stocktaking/rule/updateStatus', params);
  },
  batchCreatePlan(params) {
    return axios.post(`${businessUrl}/stocktaking/batchCreateCheckPlan`, utils.exchangeParams(params));
  },
  toThirdGoodsList(params) { // 商品同步第三方列表查询
    return axios.post(`${businessUrl}/goodsSyn/config/listByQo`, params);
  },
  toThirdBatchUpdateStatus(params) { // 商品同步第三方批量启用禁用
    return axios.post(`${businessUrl}/goodsSyn/config/enable`, params);
  },
  toExportFile(params) { // 导出
    return axios.post(`${businessUrl}/goodsSyn/list/export`, params);
  },
  searchGoods(params) {
    return axios.get(`${businessUrl}/goodsSyn/config/info?${utils.exchangeParams(params)}`);
  },
  toThirdAddGood(params) { // 商品同步第三方添加新商品
    return axios.post(`${businessUrl}/goodsSyn/config/add`, params);
  },
  toThirdEditGood(params) { // 商品同步第三方编辑新商品
    return axios.post(`${businessUrl}/goodsSyn/config/edit`, params);
  },
  toThirdSearchStore(params) { // 商品同步第三方查询首营门店
    return axios.get(`${businessUrl}/goodsSyn/store/list?${utils.exchangeParams(params)}`);
  },
  toUploadFile(params) { // 批量添加文件
    return axios.post(`${businessUrl}/goodsSyn/config/batchAdd`, params,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
  },
  receiveInSearch(params) {
    return axios.get(`${businessUrl}/receivableLimit/listInventory?${utils.exchangeParams(params)}`);
  },
  receiveInAnalyzeSea(params) {
    return axios.get(`${businessUrl}/receivableLimit/listStatistics?${utils.exchangeParams(params)}`);
  },
  receiveInDetailSea(params) {
    return axios.get(`${businessUrl}/receivableLimit/listStatisticsDetail?${utils.exchangeParams(params)}`);
  },
  receiveInDownload(params) {
    return axios.get(`${businessUrl}/receivableLimit/download/inventory?${utils.exchangeParams(params)}`);
  },
  receiveInTableDownload(params) {
    return axios.get(`${businessUrl}/receivableLimit/download/statistics?${utils.exchangeParams(params)}`);
  },
  interactionInfo(params) { // 相互作用详情
    return axios.get(`${baseWebUrl}/chemistry/interaction/info?${utils.exchangeParams(params)}`);
  },
  interactionDel(params) { // 相互作用删除
    return axios.get(`${baseWebUrl}/chemistry/interaction/delete?${utils.exchangeParams(params)}`);
  },
  interactionAdd(params) { // 添加相互作用
    return axios.post(`${baseWebUrl}/chemistry/interaction/add`, params);
  },
  interactionList(params) { // 列表分页查询
    return axios.post(`${baseWebUrl}/chemistry/interaction/listQo`, params);
  },
  interactionEdit(params) { // 修改相互作用
    return axios.post(`${baseWebUrl}/chemistry/interaction/edit`, params);
  },
  interactionBatchAdd(params) { // 相互作用批量添加
    return axios.post(`${baseWebUrl}/chemistry/interaction/batchAdd`, params);
  },
  interactionRecord(params) { // 相互作用操作日志
    return axios.get(`${businessUrl}/editLog/list?${utils.exchangeParams(params)}`);
  },
  getHistoryList(params) { // 批量创建盘点计划历史
    return axios.get(`${businessUrl}/stocktaking/listHead?${utils.exchangeParams(params)}`);
  },
  // 活动收款配置
  getGoodsBaseList(params) { // 查询商品信息
    return axios.get(`/v1/erp-base-web/goods/base/list?${utils.exchangeParams(params)}`);
  },
  addActivityCollection(params) { // 添加活动收款配置
    return axios.post('/v1/erp-sys-web/proceedsType/store/goods/add', params);
  },
  enableActivityCollection(params) { // 活动收款启用禁用
    return axios.post('/v1/erp-sys-web/proceedsType/store/goods/enable', params);
  },
  getActivityCollectionList(params) { // 查询商品信息
    return axios.get(`/v1/erp-sys-web/proceedsType/store/goods/list?${utils.exchangeParams(params)}`);
  },
  getTimingList(params) { // 定时导出任务
    return axios.get(`/v1/erp-sys-web/download/file/list/monthEnd?${utils.exchangeParams(params)}`);
  },
  getTumourList(params) { // 肿瘤药列表
    return axios.get(`/v1/erp-base-web/goods/base/antitumor/list?${utils.exchangeParams(params)}`);
  },
  submitTumourDrug(params) { // 提交肿瘤药
    return axios.post('/v1/erp-base-web/goods/base/antitumor/addOrUpdate', params);
  },
  batchTumourDrug(params) { // 批量提交
    return axios.post('/v1/erp-base-web/goods/base/antitumor/upload', params,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
  },
  exportDrugList(params) { // 导出
    return axios.get(`/v1/erp-base-web/goods/base/antitumor/export?${utils.exchangeParams(params)}`);
  },
  deleteTumourDrug(params) {
    return axios.post('/v1/erp-base-web/goods/base/antitumor/delete', params);
  },
  // 列表
  roleMutexList(params) {
    return axios.get(`/v1/erp-sys-web/sys/role/repel/list?${utils.exchangeParams(params)}`);
  },
  // 添加
  addRoleMutex(params) {
    return axios.post('/v1/erp-sys-web/sys/role/repel/add', params);
  },
  // 编辑
  editRoleMutex(params) {
    return axios.post('/v1/erp-sys-web/sys/role/repel/update', params);
  },
  // 删除
  deleteRoleMutex(params) {
    return axios.post('/v1/erp-sys-web/sys/role/repel/delete', params);
  },
  // 启用角色
  roleOpen(params) {
    return axios.post('/v1/erp-sys-web/sys/role/repel/enable', params);
  },
  roleClose(params) {
    return axios.post('/v1/erp-sys-web/sys/role/repel/disable', params);
  },
  // 效期订正列表
  dateRevisalList(params) {
    return axios.get(`/v1/erp-business-web/data/revise/list?${utils.exchangeParams(params)}`);
  },
  dateRevisalSearch(params) {
    return axios.get(`/v1/erp-business-web/data/inventory/batch/list?${utils.exchangeParams(params)}`);
  },
  dateRevisalSubmit(params) {
    return axios.post('/v1/erp-business-web/data/revise/submit', params);
  },
  notify(params) {
    return axios.get(`/v1/erp-base-web/dtpPatients/infusion/sms/notify?${utils.exchangeParams(params)}`);
  },
  verifyList(params) { // 核对记录列表
    return axios.get(`/v1/erp-base-web/invoice/verify/list?${utils.exchangeParams(params)}`);
  },
  verifyDetail(params) { // 核对明细列表
    return axios.get(`/v1/erp-base-web/invoice/verify/detail/list?${utils.exchangeParams(params)}`);
  },
  verifyDownload(params) { // 核对明细导出
    return axios.post('/v1/erp-base-web/invoice/verify/detail/download', utils.exchangeParams(params), {
      responseType: 'blob',
      timeout: 60000,
    });
  },
  verifyReMatch(params) { // 重新匹配
    return axios.get(`/v1/erp-base-web/invoice/verify/detail/reMatch?${utils.exchangeParams(params)}`);
  },
  verifySubmit(params) { // 上传
    return axios.post('/v1/erp-base-web/invoice/verify/file/submit', params,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
  },
};
